import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDashboardDialog } from '@actions/dashboard-actions';
import { deleteWorkflowTaskType } from '@actions/workflow-actions';
import * as dialog from '@constants/dialogs';
import Dialog from '@shared/dialogs/dialog';
import DialogActions from '@shared/dialogs/dialog-actions';

const DeleteWorkflowTaskTypeDialog = () => {
  const dispatch = useDispatch();

  const { activeDialogs, dialogParams } = useSelector(state => state.dashboard);

  const { id, taskType = {}, workflowName } = dialogParams[dialog.DELETE_WORKFLOW_TASK_TYPE] || {};
  const isDialogActive = activeDialogs[dialog.DELETE_WORKFLOW_TASK_TYPE];

  const onClose = useCallback(
    () => {
      dispatch(closeDashboardDialog(dialog.DELETE_WORKFLOW_TASK_TYPE));
    },
    [dispatch]
  );

  const onDelete = useCallback(
    () => dispatch(deleteWorkflowTaskType(id, taskType)),
    [dispatch, id, taskType]
  );

  if (!isDialogActive) {
    return null;
  }

  return (
    <Dialog
      actions={
        <DialogActions
          onCancel={onClose}
          onSubmit={onDelete}
          submitLabel="REMOVE"
          submitColor="secondary"
        />
      }
      title="Remove task template?"
    >
      Task template "{taskType.name}" will no longer be available to create new tasks in any workflows of "{workflowName}".
      However, you can still work with tasks that already exist.
    </Dialog>
  );
};

export default DeleteWorkflowTaskTypeDialog;
